import Route from 'mewe/routes/route';
import { service } from '@ember/service';
import AccountApi from 'mewe/api/account-api';
import CurrentUserStore from 'mewe/stores/current-user-store';

export default class AmbassadorRoute extends Route {
  @service router;

  async beforeModel() {
    try {
        const currentUser = await AccountApi.getCurrentUser();
        CurrentUserStore.send('handle', currentUser, true);
        if (!currentUser.ambassador) {
          this.router.transitionTo('app.myworld');
          return;
        }
      } catch (error) {
        if (error.status === 401) {
          this.router.transitionTo('login');
          return;
        }
        throw error;
      }
  }

  async model() {
    const contracts = await AccountApi.getAmbassadorContracts();
    // return last contract
    return contracts[contracts.length - 1];
  }
}